import React, { createContext, useReducer } from 'react'

import {
  AnesthesistModel,
  CalendarSchedule,
  DoctorModel,
  EquipamentsModel,
  PatientModel,
  SurgeryCenterSchedule,
  SurgicalOrderModel,
  SurgicalScheduleModel
} from 'domain/entities/surgical-schedule-model'

export type SurgicalScheduleModelContext = {
  dispatch: any
  state: SurgicalSchedulingState
}

export const SurgicalSchedulingContext = createContext({})

export type SurgicalSchedulingState = {
  surgical_order_id: number
  procedure: any
  anesthetist: AnesthesistModel
  equipaments: EquipamentsModel[]
  doctor: DoctorModel
  patient: PatientModel
  time: {
    justificative: string
    predicted_time: string
    requested_time: string
  }
  appointments: any
  general_observation: string
  surgical_center_schedule: SurgeryCenterSchedule
  schedules: CalendarSchedule[]
  surgical_order: SurgicalOrderModel
  reason_to_scheduling_is_another_date: string
  observation_to_scheduling_is_another_date: string
  selectedDate: string
  selectedHourStart: string
  selectedHourEnd: string
  selectedHourEndWithPreparation: string
  selectedRoomId: number
  surgery_day: string
  requested_by_id: number
  requested_by_name: string
  scheduled_by_id: number
  scheduled_by_name: string
  createdAt: string
  updatedAt: string
  status: string
  toggleRefreshCalendar: boolean
} & SurgicalOrderModel

type Actions = {
  payload:
    | number
    | AnesthesistModel[]
    | EquipamentsModel[]
    | SurgicalOrderModel
    | { general_observation: string }
    | any
    | { surgery_center_name: string; room_id: number }
  type:
    | 'START'
    | 'INFORMATIONS'
    | 'EQUIPAMENTS'
    | 'ANESTHESIA'
    | 'TIME'
    | 'APPOINTMENTS'
    | 'COMMENT'
    | 'SURGICAL_CENTER'
    | 'SELECTED_DATE'
    | 'SURGICAL_CENTER_SCHEDULE'
    | 'CALENDAR_SCHEDULE'
    | 'SELECTED_HOUR_START'
    | 'SELECTED_HOUR_END_WITH_PREPARATION'
    | 'SELECTED_HOUR_END'
    | 'OBSERVATION_SCHEDULING_ANOTHER_DATE'
    | 'REASON_SCHEDULING_ANOTHER_DATE'
    | 'SELECTED_ROOM_ID'
    | 'FINISH_SCHEDULE_SUCCESS'
}

const reducer = (state: SurgicalScheduleModel, action: Actions) => {
  switch (action.type) {
    case 'START':
      return { ...state, ...action.payload }
    case 'TIME':
      return {
        ...state,
        time: {
          ...state.time,
          requested_time: action.payload.requested_time
        }
      }
    case 'SURGICAL_CENTER':
      return {
        ...state,
        surgical_order: {
          ...state.surgical_order,
          room_id: action.payload.room_id,
          surgery_center_name: action.payload.surgery_center_name
        }
      }

    case 'EQUIPAMENTS':
      return { ...state, equipaments: action.payload }

    case 'SELECTED_ROOM_ID':
      return { ...state, selectedRoomId: action.payload }

    case 'SELECTED_DATE':
      return { ...state, selectedDate: action.payload }

    case 'SELECTED_HOUR_START':
      return { ...state, selectedHourStart: action.payload }

    case 'SELECTED_HOUR_END':
      return { ...state, selectedHourEnd: action.payload }

    case 'SELECTED_HOUR_END_WITH_PREPARATION':
      return { ...state, selectedHourEndWithPreparation: action.payload }

    case 'SURGICAL_CENTER_SCHEDULE':
      return { ...state, surgical_center_schedule: action.payload }

    case 'CALENDAR_SCHEDULE':
      return { ...state, schedules: action.payload }

    case 'OBSERVATION_SCHEDULING_ANOTHER_DATE':
      return {
        ...state,
        observation_to_scheduling_is_another_date: action.payload
      }

    case 'REASON_SCHEDULING_ANOTHER_DATE':
      return { ...state, reason_to_scheduling_is_another_date: action.payload }

    case 'FINISH_SCHEDULE_SUCCESS':
      return { ...state, toggleRefreshCalendar: action.payload }

    default:
      return state
  }
}

export default function SurgicalSchedulingContextWrapper(props: any) {
  const [state, dispatch] = useReducer(reducer, {} as SurgicalSchedulingState)

  return (
    <SurgicalSchedulingContext.Provider value={{ state, dispatch }}>
      {props.children}
    </SurgicalSchedulingContext.Provider>
  )
}
